<script>
    import request from './request.vue';
	import { format } from "date-fns";
    
    const companyBranchSchema = [
        {
			name: "id",
			displayName: "Código",
			kind: "text",
			validation: "",
			placeholder: "",
			defaultSort: true,
			readOnly: true,
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
        {
			name: "companyId",
			displayName: "Empresa",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
			formatter: value => parseInt(value, 10),
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
        {
			name: "cnpj",
			displayName: "CNPJ",
			kind: "text",	
            validation: "required|length:14",		
			placeholder: "Digite o CNPJ da filial",			
            defaultSort: true,
            notInFilters: false,			
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
        {
			name: "name",
			displayName: "Nome",
			kind: "text",	
            validation: "required",		
			placeholder: "Digite o nome do departamento",			
            defaultSort: true,
            notInFilters: false,			
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
        {
			name: "creationDate",
			displayName: "Data do cadastro",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			notInFilters: true,
			formatter: value => format(value, "DD/MM/YYYY HH:mm"),
			creationHidden: true,			
		},
    ];

    export default {
        create: async function(entity) {
            const response = await request.send("companyBranch", "create", entity, true);
            return response.data;
        },
        getInfo: async function(id) {
            const response = await request.send("companyBranch", "read", { id }, true);
            return response.data;
        },
        updateInfo: async function(entity) {
            const response = await request.send("companyBranch", "update", entity, true);
            return response.data;
        },
        remove: async function(id) {
            return request.send("companyBranch", "delete", { id }, true);
        },
        search: async function(parameters) {
			return request.send("companyBranch", "search", parameters, true);
		},
		getSchema: function() {
            console.log('getSchema companyBranch');
			return companyBranchSchema;
		},
    }

</script>